import React from 'react'

const TextIcon = props => <svg
  width="8"
  height="10"
  viewBox="0 0 8 10"
  fill="none"
>
  <path
    d="M7.91553 20.7578V22.8018H6.84912L6.75391 21.7417H4.70361V29.0225L5.73828 29.2002V30H2.41846V29.2002L3.45312 29.0225V21.7417H1.39648L1.30762 22.8018H0.234863V20.7578H7.91553Z"
    transform="translate(0 -20)"
    fill="#333333"
  />
</svg>

export default TextIcon


// WEBPACK FOOTER //
// ./src/modules/TextControl/TextIconSvg.js